import { render, staticRenderFns } from "./NewsScreen.vue?vue&type=template&id=21cc9082&"
import script from "./NewsScreen.vue?vue&type=script&lang=js&"
export * from "./NewsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports